export enum ProgressStatus {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
}

export enum ThreatLevel {
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
}

export enum RiskAssessmentRating {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Critical = 'Critical',
}

export interface AssessmentInstance {
  id: number;
  name: string;
  sections: Section[];
  answers: AssessmentInstanceAnswer[];
}

export interface Section {
  id: number;
  sortOrder: number;
  name: string;
  questions: Question[];
  progress?: ProgressStatus;
  threats?: ThreatWithQuestions[];
}

export interface Question {
  id: number;
  sectionId: number;
  text: string;
  explanation: string;
  complianceStatus: string;
  isFirstQuestion: boolean;
  options: QuestionOption[];
}

export interface QuestionOption {
  id: number;
  questionId: number;
  nextQuestionId: number;
  text: string;
  isBad: boolean;
}

export interface AssessmentInstanceAnswer {
  id?: number;
  assessmentInstanceId: number;
  questionOptionId: number;
}

export interface ThreatWithQuestions {
  assessmentInstanceThreat: AssessmentInstanceThreat;
  questions: QuestionWithOption[];
}

export interface AssessmentInstanceThreat {
  assessmentInstanceId?: number;
  isApplicable: boolean;
  likelihood: ThreatLevel;
  impact: ThreatLevel;
  threat: Threat;
}

export interface QuestionWithOption {
  question: string;
  questionOption: QuestionOption;
}

export interface Threat {
  id: number;
  vulnerability: string;
  text: string;
}

export interface ThreatResponse {
  threatId: number;
  isApplicable: boolean;
  likelihood: ThreatLevel;
  impact: ThreatLevel;
}

export interface RegistrationRequest {
  emailAddress: string;
  companyName: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  phoneNumber: string;
}

export interface SessionToken {
  readonly exp: number;
  readonly iat: number;
  readonly iss: string;
  readonly jti: string;
  readonly nbf: number;
  readonly sub: string;
  // Custom claims
  readonly userId: string;
  readonly email: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly userRoles: string[];
  readonly companyId: string;
  readonly supportAccessCompanyId: string | null;
}

// We only care about the `name` field, which is used on the report cover page
export interface Company {
  name: string;
}
